import { FormattedMessage, useIntl } from 'react-intl'
import { useMutation, useApolloClient, gql } from '@apollo/client'

import styled from 'styled-components'

import { getUnprocessableErrors } from 'utils/error'
import { Button } from 'components/v2/Button'
import Modal from 'components/v2/Modal'
import Heading from 'components/v2/Heading'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import { changeTypeMessages } from 'features/Changes/components/Type/messages'
import { resolvers as changesResolvers } from 'resolvers/changes'

const ModalContainer = styled(Modal.Container)`
  max-width: 600px;
`

const CANCEL_CHANGE = gql`
  mutation CancelTickets($changeId: ID!) {
    cancelChange(input: { id: $changeId })
  }
`

const INTERNAL_CANCEL_CHANGE = gql`
  mutation InternalCancelChange($changeId: ID!) {
    cancelChange(changeId: $changeId) @client
  }
`

export const CancelChangeModal = ({ change, closeModal }: TSFixMe): TSFixMe => {
  const intl = useIntl()
  const client = useApolloClient()
  client.addResolvers(changesResolvers)

  const [internalCancelChange] = useMutation(INTERNAL_CANCEL_CHANGE)
  const [cancelChange, { loading, error }] = useMutation(CANCEL_CHANGE, {
    onCompleted() {
      internalCancelChange({
        variables: {
          changeId: change.id
        }
      })
      closeModal()
    }
  })

  const handleCancelChange = (): TSFixMe => {
    cancelChange({
      variables: {
        changeId: change.id
      }
    })
  }

  // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
  const typeMessage = changeTypeMessages[change.type]
    ? // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
      intl.formatMessage(changeTypeMessages[change.type])
    : change.type

  return (
    <ModalContainer large>
      <Modal.Header>
        <Heading.H5>
          <FormattedMessage
            id="changes.cancellation.title"
            defaultMessage="Cancel change {id}"
            values={{
              id: change.id.substring(0, 8)
            }}
          />
        </Heading.H5>
      </Modal.Header>

      <Modal.Content>
        <FormattedMessage
          id="changes.cancellation.confirmMessage"
          defaultMessage="Are you sure to cancel the {type}?"
          values={{
            type: typeMessage
          }}
        />
      </Modal.Content>

      <Modal.Footer>
        {error && (
          <Modal.ErrorMessage>
            <ErrorMessage errors={getUnprocessableErrors(error)}>
              <FormattedMessage
                id="changes.cancellation.error"
                defaultMessage="There was an error while cancelling the {type}"
                values={{
                  type: typeMessage
                }}
              />
            </ErrorMessage>
          </Modal.ErrorMessage>
        )}
        <Modal.Actions>
          <Button kind="cancel" onClick={(): TSFixMe => closeModal()}>
            <FormattedMessage id="modal.actions.close" defaultMessage="No, close" />
          </Button>
          <Button kind="primary" loading={loading} onClick={handleCancelChange}>
            <FormattedMessage id="changes.cancellation.action" defaultMessage="Cancel change" />
          </Button>
        </Modal.Actions>
      </Modal.Footer>
    </ModalContainer>
  )
}
